import * as constants from "../../utils/deviceType.utils";

import * as deviceInfo from "../actions/deviceInfo.actions";

const DEFAULT_WIDTH = 1024;
const DEFAULT_HEIGHT = 768;

const defaultState = {
  width: DEFAULT_WIDTH,
  height: DEFAULT_HEIGHT,
  userAgent: navigator.userAgent,
  orientation:
    DEFAULT_WIDTH >= DEFAULT_HEIGHT
      ? constants.ORIENTATION_LANDSCAPE
      : constants.ORIENTATION_PORTRAIT,
  deviceType: constants.DEVICE_SMALL
};

export function reducer(state = defaultState, action) {
  switch (action.type) {
    case deviceInfo.UPDATE:
      return action.payload;

    default:
      return state;
  }
}

export const getDeviceType = state => state.deviceType;
